import React from "react";
import Select from "../nativeBase-ui/Select";
import i18n, { setLanguage } from "../locales/translate";
import RNRestart from "react-native-restart";
export enum Language {
  EN = "en",
  FA = "fa",
}

const languages = [
  { value: Language.FA, label: "فارسی" },
  { value: Language.EN, label: "English" },
];

const MultiLanguage = () => {
  const changeLanguage = async (locale: Language) => {
    await setLanguage(locale);
    if (RNRestart) {
      RNRestart.Restart && RNRestart.Restart();
    } else {
      window?.location.reload();
    }
  };
  const currentLocale = i18n.currentLocale();

  return (
    <Select
      data={languages}
      value={currentLocale}
      onChangeText={(value: Language) => {
        changeLanguage(value);
      }}
      style={{
        height: 45,
      }}
      containerStyle={{ flex: 1.5, width: 200}}
    />
  );
};

export default MultiLanguage;
